import { render, staticRenderFns } from "./SearchCardActivityPanel.vue?vue&type=template&id=a252b88a&scoped=true&"
import script from "./SearchCardActivityPanel.vue?vue&type=script&lang=js&"
export * from "./SearchCardActivityPanel.vue?vue&type=script&lang=js&"
import style0 from "./SearchCardActivityPanel.vue?vue&type=style&index=0&id=a252b88a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a252b88a",
  null
  
)

export default component.exports